// import plusmp3 from "../../../audio/+.mp3";
// import minusmp3 from "../../../audio/-.wav";

import { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { handleBet } from "../../../redux/actions/postActions";

import useSound from "use-sound";
import divideSFX from "../assets/audio/globals/divideSFX.mp3";
import multiplySFX from "../assets/audio/globals/multiplySFX.mp3";
// import PlusSound from "../assets"

export default function useBetOperations(
  MyBet,
  volume,
  sound,
  handleNotification,
  minBet,
  maxBet,
  curr,
  precision
) {
  if (MyBet) MyBet = (+MyBet).toFixed(precision);
  const [useBet, setbet] = useState(MyBet);
  const [playMultiplySFX] = useSound(multiplySFX, {
    volume: volume,
  });
  const [playDivideSFX] = useSound(divideSFX, { volume: volume });

  const mult = 2;
  const divd = 1 / 2;
  const [first, setfirst] = useState("");
  const [isHold, setisHold] = useState(false);
  const [trigger, settrigger] = useState("");
  const [min, setmin] = useState(minBet);
  const [max, setmax] = useState(maxBet);
  const [prec, setPrec] = useState(precision);
  const [currency, setcurrency] = useState(curr);
  const diff = 1 / Math.pow(10, precision);


  useEffect(() => {
    setmin(minBet);
  }, [minBet]);
  useEffect(() => {
    setmax(maxBet);
  }, [maxBet]);
  useEffect(() => {
    setcurrency(curr);
  }, [curr]);
  useEffect(() => {
    setPrec(precision);
  }, [precision]);
  useEffect(() => {
    setbet(MyBet);
  }, [MyBet]);
  const plus = () => {
    sound === "1" && playMultiplySFX();

    setbet((b) =>
      +b + +diff > max
        ? (() => {
          handleNotification(
            `Maximum stake limit is ${max.toFixed(prec)} ${currency}`
          );
          return max.toFixed(prec);
        })()
        : (+b + +diff).toFixed(prec)
    );
  };
  const minus = () => {
    sound === "1" && playDivideSFX();

    setbet((b) =>
      b - diff < min
        ? (() => {
          handleNotification(
            `Minimum stake limit is ${min.toFixed(prec)} ${currency}`
          );
          return min.toFixed(prec);
        })()
        : (b - diff).toFixed(prec)
    );
  };
  const multiply = (n) => {
    sound === "1" && playMultiplySFX();
    setbet((b) =>
      b * (n || mult) > max
        ? (() => {
          handleNotification(
            `Maximum stake limit is ${max.toFixed(prec)} ${currency}`
          );
          return max.toFixed(prec);
        })()
        : (b * (n || mult)).toFixed(prec)
    );
  };
  const divide = () => {
    sound === "1" && playDivideSFX();

    setbet((b) =>
      b * divd < min
        ? (() => {
          handleNotification(
            `Minimum stake limit is ${min.toFixed(prec)} ${currency}`
          );
          return min.toFixed(prec);
        })()
        : (b * divd).toFixed(prec)
    );
  };
  useEffect(() => {
    let interval = null;
    let mytimeout = null;
    if (isHold) {
      if (trigger === "acceleratablePlus") {
        mytimeout = setTimeout(() => {
          interval = setInterval(() => {
            let last = Date.now();
            let d = last - first;
            let df = d / (10000 ^ prec);
            sound === "1" && playMultiplySFX();
            setbet((b) =>
              +b + +df > max
                ? (() => {
                  handleNotification(
                    `Maximum stake limit is ${max} ${currency}`
                  );
                  return max.toFixed(prec);
                })()
                : (+b + +df).toFixed(prec)
            );
          }, 80);
        }, 400);
      } else {
        mytimeout = setTimeout(() => {
          interval = setInterval(() => {
            let last = Date.now();
            let d = last - first;
            let df = d / (10000 ^ prec);
            sound === "1" && playDivideSFX();

            setbet((b) =>
              b - +df < min
                ? (() => {
                  handleNotification(
                    `Minimum stake limit is ${min} ${currency}`
                  );
                  return min.toFixed(prec);
                })()
                : (b - +df).toFixed(prec)
            );
          }, 80);
        }, 400);
      }
    }
    return () => {
      clearInterval(interval);
      clearTimeout(mytimeout);
    };
  }, [
    isHold,
    first,
    trigger,
    playDivideSFX,
    playMultiplySFX,
    handleNotification,
    min,
    max,
    currency,
    prec,
    sound,
  ]);

  const handleButtonPress = (e) => {
    setfirst(Date.now());
    settrigger(e);
    setisHold(true);
  };

  const handleButtonRelease = () => setisHold(false);

  return [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ];
}
